import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import { computed, ref } from "vue";
import { SelectOption } from "@/types";
import { attributesStore } from "@/hooks";
import { TabList, TextButton, Typography } from "@/components/common";
import SaveAttributeLayout from "./SaveAttributeLayout.vue";


/**
 * Allows for editing attribute layouts.
 */
const __default__ = {
  name: "AttributeLayoutEditor",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const getTabId = (id = "") => `tab-${id}`;
const stripTabId = (tabId: string) => tabId.replace("tab-", "");

const createOpen = ref(false);

const tab = computed({
  get() {
    return getTabId(attributesStore.selectedLayoutId);
  },
  set(tab) {
    attributesStore.selectedLayoutId = stripTabId(tab);
  },
});

const layouts = computed(() => attributesStore.attributeLayouts);

const tabs = computed<SelectOption[]>(() => {
  const tabs = attributesStore.attributeLayouts.map<SelectOption>(
    ({ id, name }) => ({
      id: getTabId(id),
      name,
    })
  );

  if (createOpen.value) {
    tabs.push({ id: getTabId(), name: "New Layout" });
  }

  return tabs;
});

/**
 * Adds a new attribute layout.
 */
function handleAddLayout(): void {
  createOpen.value = true;
  tab.value = getTabId();
}

/**
 * Closes the layout creator on save.
 * @param tabId - The tab id of the saved layout.
 */
function handleSaveLayout(tabId: string): void {
  createOpen.value = false;
  tab.value = tabId;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabList), {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
    tabs: tabs.value
  }, _createSlots({
    before: _withCtx(() => [
      _createVNode(_unref(Typography), {
        r: "4",
        el: "h2",
        variant: "subtitle",
        value: "Layouts"
      })
    ]),
    after: _withCtx(() => [
      (!createOpen.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Add Layout",
            icon: "add",
            "data-cy": "button-attribute-layout-add",
            onClick: handleAddLayout
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    _renderList(tabs.value, ({ id }, idx) => {
      return {
        name: id,
        fn: _withCtx(() => [
          (id === tab.value)
            ? (_openBlock(), _createBlock(SaveAttributeLayout, {
                key: 0,
                layout: layouts.value[idx],
                onSave: handleSaveLayout
              }, null, 8, ["layout"]))
            : _createCommentVNode("", true)
        ])
      }
    })
  ]), 1032, ["modelValue", "tabs"]))
}
}

})